module.exports = __webpack_public_path__ + "static/media/sundial-bridge.46ca2dd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/sundial-bridge.jpg
// module id = 323
// module chunks = 0